import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import UsersTab from "@/components/admin/UsersTab";
import FeatureFlagsTab from "@/components/admin/FeatureFlagsTab";
import FeedbackTab from "@/components/admin/FeedbackTab";
import ButtonsTab from "@/components/admin/ButtonsTab";

export default function AdminPage() {
  return (
    <div className="container mx-auto py-10">
      <Tabs defaultValue="users" className="w-full">
        <TabsList className="grid w-full grid-cols-4 max-w-[800px] mx-auto mb-8">
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="feature-flags">Feature Flags</TabsTrigger>
          <TabsTrigger value="feedback">Feedback</TabsTrigger>
          <TabsTrigger value="buttons">Buttons</TabsTrigger>
        </TabsList>
        
        <TabsContent value="users">
          <UsersTab />
        </TabsContent>
        
        <TabsContent value="feature-flags">
          <FeatureFlagsTab />
        </TabsContent>

        <TabsContent value="feedback">
          <FeedbackTab />
        </TabsContent>

        <TabsContent value="buttons">
          <ButtonsTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}